module.exports = __webpack_public_path__ + "10618969eab0a787801524d3f0803a3a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/cloud.png
// module id = 251
// module chunks = 1